import _ from 'underscore';
import Backbone from 'backbone';
import { request } from './request';

import { state } from '../state-manager/state-model';

/**
 * Backbone 모델과 콜렉션의 Persistent 저장 함수를 오버라이드해서 Backend API와 통신하기 쉽게 한다.
 * @param {*} method create|read|update|delete 모델에서 fetch, save, destroy 할 때 Backbone 이 주입
 * @param {*} model 현재 모델 Backbone 이 주입
 * @param {*} options 모델에서 fetch, save, destroy 호출 시 넘어오는 인자와 Backbone 기본 인자가 합쳐짐
 */
Backbone.sync = function (method, model, options) {
  /**
   * game 명을 모델에 정의하거나 fetch|save|destroy 호출 시 넘겨야 함
   */
  var game = options.game || model.game || model.attributes.game || state.get('game');

  if (!game) {
    throw new Error('Request error. Game name required.');
  }

  switch (method) {
    case 'read':
      return request(game, model.url).done(options.success).fail(options.error);
    case 'create':
    case 'update':
      return request(game, model.url, {
        method: 'post',
        body: options.patch ? model.changed : _.omit(model.attributes, ['game', 'id'])
      })
        .done(options.success)
        .fail(options.error);
    case 'patch':
      return request(game, model.url, {
        method: 'post',
        body: model.changed
      })
        .done(options.success)
        .fail(options.error);
  }
};
